import { render, staticRenderFns } from "./unauthorize-message.vue?vue&type=template&id=0902129a&scoped=true"
import script from "./unauthorize-message.vue?vue&type=script&lang=js"
export * from "./unauthorize-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0902129a",
  null
  
)

export default component.exports